import { SecondaryStatusTag } from "@graffer-inc/console-design-kit";
import { QualifiedInvoiceIssueRequest } from "@graffer-inc/smart-apply";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { SmartApplyR } from "../../../route";

type Props = {
  applicationId: string;
  revokedQualifiedInvoices: NonNullable<
    QualifiedInvoiceIssueRequest["revokedQualifiedInvoices"]
  >;
};

export const QualifiedInvoiceRevokedList: React.FC<Props> = ({
  applicationId,
  revokedQualifiedInvoices,
}) => {
  return (
    <>
      <h3 className="title is-size-6 mb-4 pt-2">交付履歴</h3>
      <ul>
        {revokedQualifiedInvoices.map((revoked, i) => {
          return (
            <li key={i} className="is-flex is-align-items-center mb-2">
              <span className="mr-2">
                {dayjs(revoked.issuedAt).format("YYYY年M月D日 HH:mm")}
              </span>
              <span className="mr-2">
                <SecondaryStatusTag type="DARK">無効</SecondaryStatusTag>
              </span>
              <Link
                to={SmartApplyR.ApplicationQualifiedInvoiceShow.link({
                  id: applicationId,
                  qualifiedInvoiceId: revoked.id,
                })}
              >
                詳細
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
};
